import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

export const Alert = (title = 'Sucesso!', text = '', success = true, toastAlert = true, info = false) => {
    if (info) {
        Swal.fire({
            title: title,
            text: text,
            icon: "info"
        });
        return;
    }

    if (success && toastAlert) {
        toast.success(
            <div>
                <p className="font-bold text-green-600">{title}</p>
                <p>{text}</p>
            </div>
        );
        return;
    }

    if (success && !toastAlert) {
        Swal.fire({
            title: title,
            html: text.replace(/\n/g, '<br>'),
            icon: "success"
        });
        return;
    }

    if (!success && toastAlert) {
        toast.error(
            <div>
                <p className="font-bold text-green-600">{title}</p>
                <p>{text}</p>
            </div>
        );
        return;
    }

    if (!success && !toastAlert) {
        Swal.fire({
            title: title === '' ? "Atenção" : title,
            html: text.replace(/\n/g, '<br>'),
            icon: "error"
        });
    }
};

export const Question = (title, text = '') => {
    return new Promise((resolve) => {
        Swal.fire({
            title: title,
            text: text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SIM",
            cancelButtonText: "NÃO"
        }).then((result) => {
            resolve(result.isConfirmed);
        });
    });
};
